// Path: ./src/app/pages/CreatePreferenceCuisinePage/handleSaveCuisine.ts
import { useNavigate } from "react-router-dom";
import { GfPreferenceCuisine } from "@swagger/typescript-fetch-goflyer";
import i18n from "i18next";

import { messages } from "../../../locales/messages";
import { adminApiService } from "../../../utils/api";
import { toastError, toastSuccess } from "../../../utils/pageUtil/toast";
import { useLoading } from "../../../contextApi/LoadingContext";
import { useAuthHeaders } from "../../../hooks/useAuthHeaders";
import {
  CuisineFormState,
  buildCuisinePayload,
} from "../../../utils/preference/cuisinePayload";

export const useHandleSaveCuisine = () => {
  const navigate = useNavigate();
  const { showLoadingScreen } = useLoading();
  const authHeaders = useAuthHeaders();

  return async (form: CuisineFormState, cuisineId?: string) => {
    if (!form.name.trim()) {
      toastError(i18n.t(messages.preference_cuisine_name_required()));
      return;
    }

    if (form.index.trim() && Number.isNaN(parseInt(form.index, 10))) {
      toastError(i18n.t(messages.preference_cuisine_index_invalid()));
      return;
    }

    const payload = buildCuisinePayload(form, { isUpdate: Boolean(cuisineId) });

    showLoadingScreen(true);
    const result = cuisineId
      ? await adminApiService.updateOneBaseGfPreferenceCuisineAdminControllerGfPreferenceCuisine(
          payload as unknown as GfPreferenceCuisine,
          cuisineId,
          authHeaders,
        )
      : await adminApiService.createOneBaseGfPreferenceCuisineAdminControllerGfPreferenceCuisine(
          payload as unknown as GfPreferenceCuisine,
          authHeaders,
        );
    showLoadingScreen(false);

    if (result === undefined) return;

    toastSuccess(
      i18n.t(
        cuisineId
          ? messages.preference_cuisine_update_success()
          : messages.preference_cuisine_create_success(),
      ),
    );
    navigate(-1);
  };
};
